import InputUI from "@UI/InputUI";
import SelectSuggestUI from "@UI/SelectSuggestUI";
import { inject, observer } from "mobx-react";

import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";

import React, { useState, useEffect, useMemo, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

import "./style.scss";
import { differ } from "@utils";
import ButtonUI from "@UI/ButtonUI";

const CompaniesOrd = inject("mainStore")(
    observer(({ mainStore, changeableData, inputFieldsDisable, isScroll, getDetailData }) => {
        const { secondParam } = useParams();
        const navigation = useNavigate();

        const detailData = mainStore.getMainStore("detailData");
        const kktuList = mainStore.getMainStore("suggest.promo_kktuCategory_suggest");
        const isDraft = inputFieldsDisable();
        const eridToRegenerate = mainStore.getMainStore("eridToRegenerate");

        useEffect(() => {
            if (isScroll) {
                let el = document.getElementById("ord");

                el.scrollIntoView({ behavior: "auto" });
            }
        }, []);

        const [data, setData] = useState({
            title: `${changeableData?.vendor?.name}_${changeableData?.title}`,
            targetLink: "",
            kktuCategory: "",
            contractId: "",
            isTargetLink: false,
        });
        const [selectContract, setSelectContract] = useState([]);

        useEffect(() => {
            if (detailData.ordData) {
                setData({
                    ...detailData.ordData,
                    title: detailData?.vendor ? `${detailData?.vendor?.name}_${detailData?.title}` : `${detailData.ordData.title}`,
                    targetLink: detailData.activationLink ? detailData.activationLink : "",
                    isTargetLink: detailData.activationLink ? true : false,
                });
            } else {
                if (detailData.vendor && detailData.title) {
                    setData((prev) => {
                        return { ...prev, title: `${detailData?.vendor?.name}_${detailData?.title}`, targetLink: detailData.activationLink ? detailData.activationLink : "", isTargetLink: detailData.offerType !== "leads" };
                    });
                }
            }
        }, [detailData.vendor]);

        useEffect(() => {
            if (detailData.vendorId) {
                getContract();
            }
        }, [detailData.vendorId]);

        const hasOrdChange = useMemo(() => {
            const baseOrd = detailData?.ordData
                ? {
                      ...detailData.ordData,
                      targetLink: detailData.activationLink ? detailData.activationLink : "",
                      isTargetLink: detailData.activationLink ? true : false,
                  }
                : {};
            const diff = differ(baseOrd, data) || {};
            return Object.hasOwn(diff, "kktuCategory") || Object.hasOwn(diff, "targetLink");
        }, [detailData?.ordData, detailData?.activationLink, data]);

        useEffect(() => {
            if (hasOrdChange) {
                if (eridToRegenerate !== "required") {
                    mainStore.setMainStore("eridToRegenerate", "required");
                }
                return;
            }

            if (eridToRegenerate === "required") {
                mainStore.setMainStore("eridToRegenerate", null);
            }
        }, [hasOrdChange]);

        const getContract = async () => {
            const resp = await mainStore.getByUrl(`promo/suggest_list?collection=contracts&filter[rows]=999999999&filters[vendorId]=${detailData.vendorId}&filters[contractType]=CONTRACT_TYPE_SERVICE||CONTRACT_TYPE_INTERMEDIARY`);
            if (resp && resp.success) {
                const contract = resp.data;
                setSelectContract(contract);
            }
        };

        const selectedCountryTemplate = (option, props) => {
            if (option) {
                return (
                    <div className="contract__item">
                        <div className="number">
                            {"ID Договора "}
                            <span>{option.ozonId}</span>
                        </div>
                        <span className="name">
                            {option.comment || ""} от {moment(option.contractDate).format("DD.MM.YYYY")}
                        </span>
                    </div>
                );
            } else {
                return <span>{selectContract.length ? "Выберите из списка" : "Договоры отсутствуют"}</span>;
            }
        };

        const countryOptionTemplate = (option) => {
            return (
                <div className="contract__item">
                    <div className="number">
                        {"ID Договора "}
                        <span>{option.ozonId}</span>
                    </div>
                    <span className="name">
                        {option.comment || ""} от {moment(option.contractDate).format("DD.MM.YYYY")}
                    </span>
                </div>
            );
        };

        const selectedTemplate = (option, props) => {
            if (option) {
                return (
                    <div className="contract__item">
                        <div>{option.code}</div>
                        <span className="name">{option.title}</span>
                    </div>
                );
            } else {
                return <span>Выберите из списка</span>;
            }
        };

        const countryTemplate = (option) => {
            return (
                <div className="contract__item">
                    <div>{option.code}</div>
                    <span className="name">{option.title}</span>
                </div>
            );
        };

        const handleAddErid = async () => {
            // const elScreenshot = document.getElementById("screen");

            // const nameImg = `Partner name_${changeableData.vendor.name} Offer name_${changeableData.title} mobile.png`;
            // const img = await captureScreenshot(elScreenshot, mainStore, nameImg);
            if (detailData && !detailData.dateEnd) {
                detailData.dateEnd = "2125-01-01T00:00+00:00";
            }

            const body = { ...detailData, ordData: { ...data } };

            // if (img && img.Location) {
            if (secondParam === "add") {
                const draft = isDraft ? { active: false, draft: true } : { active: true, draft: false };
                const postResp = await mainStore.postByUrl("/promo/offers", { ...body, ...draft }, "detailData", true, true);
                if (postResp && postResp.success) {
                    const resp = await mainStore.postByUrl(`promo/createCreativeInOzon`, { ...data, offerId: postResp.data._id }, "", false);
                    if (resp && resp.success) {
                        mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: "ERID сформирован. Вы можете опубликовать оффер " });
                        navigation(`/companies/${postResp.data._id}`, { state: { scrollORD: true } });
                        mainStore.setMainStore("urlImageErid", false);
                    } else {
                        const putResp = await mainStore.putByUrl(`/promo/offers/${postResp.data._id}`, draft, false, false);
                        if (putResp && putResp.success) {
                            navigation(`/companies/${postResp.data._id}`, { state: { scrollORD: true } });
                        }
                    }
                }
            } else {
                // const putResp = await mainStore.putByUrl(`/promo/offers/${detailData._id}`, body, false, false);
                // if (putResp && putResp.success) {
                const resp = await mainStore.postByUrl(`promo/createCreativeInOzon`, { ...data, offerId: detailData._id }, false, false);
                if (resp && resp.success) {
                    mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: "ERID сформирован. Вы можете опубликовать оффер " });
                    mainStore.setMainStore("eridToRegenerate", null);
                    mainStore.setMainStore("detailData.erid", resp.data.erid);
                    getDetailData();
                }
                // }
            }
            // }
        };

        const isDisableButton = !data.title || !data.kktuCategory || !(data.contractId && selectContract.some((i) => i._id === data.contractId)) || (["required", "optional"].includes(eridToRegenerate) ? false : detailData?.erid?.length);

        return (
            <div className="companies-ord" id="ord">
                <InputUI
                    value={data.title.replace(/<\/?[^>]+(>|$)/g, "")}
                    onChange={(e) => {
                        setData((prev) => {
                            return { ...prev, title: e.target.value };
                        });
                    }}
                    placeholder="Генерируется автоматически"
                    label="Название креатива для ORD"
                    required
                />

                <SelectSuggestUI
                    options={selectContract}
                    value={data.contractId}
                    optionValue="_id"
                    filter={false}
                    onChange={(e) =>
                        setData((prev) => {
                            return { ...prev, contractId: e.value };
                        })
                    }
                    label="Выберите договор"
                    required
                    valueTemplate={selectedCountryTemplate}
                    itemTemplate={countryOptionTemplate}
                />

                <SelectSuggestUI
                    options={kktuList}
                    value={data.kktuCategory}
                    optionValue="code"
                    optionLabel="title"
                    filter={true}
                    filterBy="title,code"
                    onChange={(e) =>
                        setData((prev) => {
                            return { ...prev, kktuCategory: e.value };
                        })
                    }
                    label="Укажите ККТУ"
                    required
                    valueTemplate={selectedTemplate}
                    itemTemplate={countryTemplate}
                    placeholder="Выберите из списка"
                />

                <div className="row">
                    <div className="switch">
                        <InputSwitch
                            onChange={(e) =>
                                setData((prev) => {
                                    return { ...prev, isTargetLink: e.value };
                                })
                            }
                            checked={data.isTargetLink}
                        />
                        <label className="switch__label">Указать целевую ссылку</label>
                    </div>
                    {data.isTargetLink && (
                        <InputUI
                            value={data.targetLink}
                            onChange={(e) => {
                                setData((prev) => {
                                    return { ...prev, targetLink: e.target.value };
                                });
                            }}
                            placeholder="Укажите ccылку"
                        />
                    )}
                </div>
                <ButtonUI className="button" label={"Сгенерировать ERID"} icon="pi pi-refresh" outlined severity="success" onClick={handleAddErid} style={{ width: "100%" }} disabled={isDisableButton} />

                {detailData?.erid ? (
                    <div className="block__erid">
                        <div className="title">
                            ERID <span>{detailData.erid}</span>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }),
);

export default CompaniesOrd;
